import { render, staticRenderFns } from "./purchase-order-additional-item.vue?vue&type=template&id=439c4325&scoped=true&"
import script from "./purchase-order-additional-item.vue?vue&type=script&lang=js&"
export * from "./purchase-order-additional-item.vue?vue&type=script&lang=js&"
import style0 from "./purchase-order-additional-item.vue?vue&type=style&index=0&id=439c4325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c4325",
  null
  
)

export default component.exports